/* MovingComingSoon for Shopify (t2h "We're moving" animated section).
   Plain JavaScript, no libraries. Loaded by sections/section-moving-coming-soon.liquid.
   Edit the wording in COPY below. The section height offset lives in moving-coming-soon.css (--t2h-offset). */
(function () {
  'use strict';

const LETTERS = 'M 897.110 33.001 C 892.767 34.306, 885.077 35.242, 873.110 35.920 C 863.424 36.469, 853.050 37.594, 850.056 38.420 C 847.062 39.246, 840.987 39.891, 836.556 39.855 C 830.901 39.808, 826.563 40.421, 822 41.912 C 818.425 43.080, 811.947 44.500, 807.605 45.067 C 798.240 46.291, 794.691 47.917, 793.124 51.703 C 792.252 53.808, 792.032 138.422, 792.233 393.500 C 792.490 719.515, 792.570 732.641, 794.327 736.173 C 798.005 743.565, 797.192 743.461, 854 743.813 C 906.163 744.136, 909.973 743.898, 913.415 740.093 C 915.047 738.290, 915.142 732.352, 914.926 645.335 C 914.351 414.164, 914.240 428.336, 916.674 420.500 C 917.869 416.650, 919.159 410.912, 919.539 407.750 C 920.011 403.828, 921.338 400.171, 923.711 396.250 C 925.626 393.087, 928.696 387.529, 930.534 383.899 C 932.561 379.894, 935.803 375.567, 938.776 372.899 C 944.514 367.748, 962.241 357.844, 970.641 355.096 C 973.863 354.041, 979.200 352.024, 982.500 350.613 C 995.842 344.908, 1029.297 349.918, 1043.262 359.712 C 1045.449 361.245, 1049.532 363.858, 1052.336 365.518 C 1056.173 367.789, 1058.240 369.968, 1060.692 374.329 C 1062.483 377.515, 1065.474 381.905, 1067.339 384.083 C 1069.204 386.261, 1073.603 393.694, 1077.115 400.600 L 1083.500 413.156 1083.261 424.807 C 1083.097 432.760, 1083.517 438.432, 1084.581 442.677 C 1085.847 447.726, 1086.204 457.234, 1086.478 493.198 C 1087.114 576.867, 1087.072 727.502, 1086.413 730.744 C 1085.577 734.851, 1087.403 739.360, 1090.851 741.701 C 1093.299 743.363, 1097.297 743.522, 1143.436 743.794 C 1196.992 744.110, 1198.031 744.024, 1200.297 739.109 C 1201.226 737.094, 1201.372 699.818, 1200.937 575.500 L 1200.374 414.500 1198.090 406.500 C 1196.465 400.810, 1195.956 396.998, 1196.326 393.299 C 1197.012 386.429, 1195.101 378.667, 1189.484 365.517 C 1186.185 357.793, 1184.630 352.567, 1184.025 347.170 C 1183.213 339.935, 1182.988 339.441, 1178.586 335.221 C 1173.897 330.728, 1173.495 329.837, 1172.626 322.019 C 1172.205 318.227, 1171.358 316.815, 1167.117 312.833 C 1164.361 310.245, 1161.125 306.186, 1159.928 303.814 C 1158.730 301.441, 1155.556 297.164, 1152.875 294.310 C 1150.194 291.455, 1148 288.585, 1148 287.932 C 1148 287.279, 1145.412 284.210, 1142.250 281.111 C 1139.088 278.012, 1135.757 274.061, 1134.849 272.330 C 1133.444 269.652, 1132.328 269.002, 1127.355 267.970 C 1122.225 266.905, 1120.841 266.059, 1116.006 261.031 C 1111.871 256.730, 1109.006 254.757, 1104.500 253.105 C 1101.200 251.895, 1096.107 249.276, 1093.183 247.285 C 1088.542 244.125, 1086.826 243.574, 1079.683 242.949 C 1075.182 242.556, 1069.475 241.434, 1067 240.457 C 1060.689 237.966, 1020.438 237.917, 1012 240.391 C 1006.162 242.102, 997.164 244.459, 992.972 245.375 C 991.582 245.678, 987.851 247.940, 984.682 250.401 C 980.637 253.542, 977.313 255.208, 973.522 255.995 C 970.553 256.612, 966.770 258.103, 965.116 259.308 C 963.463 260.514, 959.947 263.031, 957.305 264.902 C 954.662 266.773, 948.450 272.221, 943.500 277.009 C 933.508 286.674, 929.759 288.520, 921.697 287.745 C 913.513 286.958, 912.836 285.473, 913.199 269.077 C 913.365 261.610, 913.388 206.162, 913.250 145.861 C 913.016 43.127, 912.890 36.089, 911.250 34.114 C 908.767 31.123, 904.479 30.785, 897.110 33.001 M 154.500 128.525 C 148.584 130.169, 131.304 131.998, 121.667 131.999 C 117.908 132, 111.173 132.935, 106.699 134.077 C 100.055 135.773, 96.908 136.036, 89.532 135.510 C 79.053 134.763, 60.400 137.037, 56.604 139.524 C 51.208 143.059, 51.474 130.552, 51.828 364 C 52.139 569.104, 52.252 580.921, 53.977 588.500 C 54.978 592.900, 56.560 601.427, 57.491 607.448 C 58.423 613.470, 60.044 620.574, 61.093 623.235 C 62.207 626.061, 63 630.528, 63 633.972 C 63 641.863, 64.229 644.660, 70.069 650.060 C 74.693 654.337, 75 654.928, 75.006 659.560 C 75.014 665.586, 76.540 668.686, 81.869 673.501 C 84.117 675.532, 86.944 678.837, 88.151 680.847 C 89.359 682.856, 92.631 687.046, 95.423 690.157 C 98.215 693.268, 101.559 697.220, 102.853 698.939 C 104.146 700.658, 106.948 702.953, 109.079 704.040 C 111.209 705.127, 113.975 707.407, 115.226 709.106 C 116.477 710.805, 119.525 713.356, 122 714.775 C 124.475 716.194, 128.988 719.687, 132.029 722.537 C 137.248 727.430, 137.938 727.760, 144.366 728.449 C 150.676 729.125, 151.567 729.533, 156.519 734.017 C 160.830 737.921, 162.795 738.984, 166.682 739.512 C 169.332 739.873, 174.650 741.058, 178.500 742.147 C 187.374 744.656, 283.523 746.303, 290.312 744.062 C 296.910 741.885, 296.793 742.860, 296.800 689.692 L 296.806 641.886 294.491 639.193 L 292.177 636.500 257.838 636 L 223.500 635.500 215.991 631.750 C 211.861 629.688, 207.361 627.988, 205.991 627.974 C 200.979 627.921, 195.915 624.345, 186.684 614.340 L 177.310 604.181 176.679 595.988 C 176.331 591.481, 175.065 584.353, 173.866 580.147 C 171.686 572.505, 171.685 572.433, 171.593 461.275 L 171.500 350.050 174.019 347.529 L 176.537 345.008 231.519 345.102 C 261.758 345.154, 288.194 345.242, 290.263 345.299 C 295.168 345.433, 297.431 343.171, 297.304 338.263 C 297.250 336.194, 297.047 313.946, 296.853 288.823 C 296.508 244.199, 296.451 243.082, 294.391 240.323 L 292.282 237.500 237.169 237.359 C 176.181 237.202, 178.665 237.463, 173.605 230.678 C 171.550 227.924, 171.488 226.701, 171 179.339 L 170.500 130.821 168.139 128.911 C 165.395 126.690, 161.498 126.580, 154.500 128.525 M 536 213.113 C 532.425 213.630, 527.878 213.822, 525.896 213.538 C 521.676 212.935, 499.086 215.447, 494 217.086 C 492.075 217.706, 486.350 218.530, 481.277 218.917 C 473.142 219.539, 471.543 219.989, 467.716 222.738 C 465.329 224.452, 459.367 227.514, 454.467 229.542 C 442.123 234.652, 429.048 242.204, 422.778 247.845 C 419.875 250.457, 416.375 253.473, 415 254.547 C 413.625 255.621, 408.972 260.325, 404.661 265 C 400.350 269.675, 394.687 275.781, 392.076 278.570 C 386.547 284.476, 378.278 298.691, 373.936 309.753 C 372.263 314.014, 369.249 319.921, 367.236 322.880 C 363.947 327.716, 363.513 329.130, 362.937 336.880 C 362.549 342.092, 361.382 347.872, 359.984 351.500 C 358.124 356.329, 357.656 359.565, 357.586 368.083 C 357.501 378.546, 357.463 378.709, 354.250 382.368 C 348.063 389.414, 350.739 394.681, 359.942 393.569 C 362.999 393.199, 385.300 392.808, 409.500 392.698 C 449.308 392.519, 453.838 392.332, 457.044 390.734 C 462.612 387.959, 464.097 384.441, 464.435 373.226 C 464.696 364.565, 465.131 362.576, 468.409 355.064 C 474.550 340.991, 485.400 327.880, 496.500 321.120 C 499.250 319.446, 503.382 316.908, 505.683 315.482 C 511.852 311.657, 520.079 310.804, 547.249 311.172 L 571.500 311.500 578 315.151 C 581.575 317.159, 586.524 319.344, 588.997 320.006 C 592.692 320.995, 595.409 323.129, 604.247 331.980 L 615 342.751 615 347.687 C 615 350.402, 615.899 356.057, 616.999 360.253 C 618.855 367.341, 618.894 368.374, 617.547 374.777 C 616.749 378.569, 615.780 385.865, 615.393 390.991 L 614.690 400.310 604.678 411.155 C 599.172 417.120, 594.386 422, 594.045 422 C 593.703 422, 590.392 424.691, 586.687 427.979 C 581.832 432.289, 578.475 434.388, 574.662 435.496 C 570.991 436.563, 568.169 438.278, 565.437 441.103 C 563.271 443.341, 559.352 446.272, 556.727 447.615 C 554.102 448.958, 549.913 452.069, 547.418 454.529 C 544.923 456.988, 542.346 459.003, 541.691 459.006 C 537.578 459.025, 532.091 461.747, 527.595 465.998 C 524.793 468.648, 520.475 471.605, 518 472.568 C 510.342 475.548, 496.085 484.250, 490.030 489.641 C 485.698 493.497, 483.162 494.962, 479.878 495.507 C 474.065 496.470, 472.269 497.480, 467.356 502.543 C 464.024 505.977, 462.112 507.042, 457.606 507.978 C 453.883 508.751, 450.405 510.381, 447.250 512.831 C 444.638 514.860, 440.624 517.735, 438.331 519.221 C 436.038 520.706, 432.888 523.593, 431.331 525.636 C 429.472 528.074, 426.282 530.356, 422.041 532.280 C 408.144 538.583, 390.336 553.948, 387.467 562.109 C 386.591 564.600, 384.064 568.286, 381.626 570.627 C 378.773 573.368, 376.906 576.265, 376.070 579.249 C 375.378 581.721, 372.820 586.164, 370.386 589.122 C 367.952 592.080, 365.521 596.300, 364.984 598.500 C 364.447 600.700, 363.107 605.875, 362.007 610 C 360.906 614.125, 358.649 623.575, 356.990 631 C 355.331 638.425, 353.347 646.795, 352.582 649.601 C 350.537 657.098, 350.517 736.166, 352.560 740.115 C 355.372 745.555, 347.625 745.361, 537.589 744.736 C 733.063 744.092, 719.593 744.612, 722.525 737.595 C 723.452 735.375, 723.766 732.559, 723.391 729.809 C 723.069 727.439, 722.736 707.099, 722.652 684.609 L 722.500 643.718 719.677 641.609 L 716.853 639.500 601.373 639.300 C 537.858 639.190, 485.060 638.836, 484.043 638.514 C 480.914 637.520, 478.681 631.380, 479.293 625.452 C 480.282 615.866, 484.314 610.330, 493.500 605.946 C 503.194 601.320, 512.075 595.325, 516.950 590.117 C 521.170 585.609, 521.941 585.209, 527.566 584.599 C 533.193 583.990, 533.989 583.576, 538.566 578.879 C 541.280 576.095, 545.750 572.793, 548.500 571.543 C 551.250 570.292, 554.873 567.691, 556.550 565.763 C 558.772 563.211, 561.218 561.794, 565.550 560.553 C 570.096 559.250, 572.680 557.695, 576.500 553.963 C 579.401 551.129, 583.389 548.419, 586 547.507 C 593.350 544.940, 607.138 536.081, 612.500 530.479 C 617.180 525.591, 617.889 525.214, 623.576 524.598 C 628.997 524.011, 630.076 523.498, 633.576 519.848 C 635.734 517.598, 639.750 514.281, 642.500 512.478 C 645.250 510.674, 649.075 507.538, 651 505.509 C 652.925 503.479, 657.176 500.459, 660.446 498.796 C 673.383 492.220, 691.503 475.940, 692.618 469.894 C 693.373 465.801, 695.549 462.147, 698.722 459.648 C 700.016 458.630, 702.369 455.231, 703.953 452.094 C 705.536 448.957, 708.417 444.493, 710.355 442.173 C 714.143 437.640, 714.492 436.871, 715.881 430 C 716.382 427.525, 718.186 420.325, 719.889 414 C 722.071 405.901, 722.989 400.244, 722.994 394.871 C 722.999 388.758, 723.524 386.096, 725.639 381.477 C 729.901 372.167, 729.879 368.427, 725.506 359.578 C 722.108 352.702, 721.829 351.524, 722.438 346.647 C 723.148 340.963, 721.732 333.078, 718.023 322.067 C 716.910 318.765, 716 314.227, 716 311.982 C 716 306.927, 714.281 303.602, 709.118 298.674 C 706.039 295.734, 704.829 293.593, 703.899 289.438 C 701.903 280.522, 693.646 270.154, 674.865 252.982 C 665.625 244.533, 664.991 244.143, 659.366 243.440 C 654.389 242.818, 653.010 242.171, 650.251 239.158 C 648.463 237.206, 647 235.259, 647 234.830 C 647 233.083, 640.750 231, 635.507 231 C 630.268 231, 629.614 230.719, 625.159 226.552 C 619.757 221.499, 616.527 220, 611.040 220 C 608.934 220, 604.351 219.135, 600.855 218.078 C 593.926 215.982, 576.583 213.718, 565.500 213.463 C 561.650 213.374, 554.900 213.047, 550.500 212.737 C 546.100 212.426, 539.575 212.596, 536 213.113';
const COPY = {
    eyebrow: 'We’re moving',
    headingTop: 'A new chapter,',
    headingBold: 'just down the road',
    newHomeLabel: 'Our new home',
    leavingLabel: 'Leaving',
    oldAddress: '80 The East Mall',
    oldCaption: 'Our home for 20 years',
    newAddress: '360 Evans Ave.',
    cityLine: 'Etobicoke, ON M8Z 1K5',
    noteBold: 'Opening date to be announced.',
    noteRest: 'Until then, visit us at 80 The East Mall.', // update once the date is known
    ariaLabel: 't2h is moving to 360 Evans Ave., Etobicoke',
};
function buildEngine() {
    var IMG_W = 1501, IMG_H = 1048, DUR = 19;
    // current store photo: size, red cube centre + size, patch rect that hides the cube when it lifts
    var OLD = { w: 1549, h: 1015, cx: 983, cy: 347, cs: 39, patch: [961, 326, 1019, 375] };
    // ---------- helpers ----------
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function prog(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function ss(t) { return t * t * (3 - 2 * t); }
    function eOut(t) { return 1 - Math.pow(1 - t, 3); }
    function eInOut(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function eBack(t) { var c1 = 1.9, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
    function px(n) { return n.toFixed(2) + 'px'; }
    function h(tag, cls, html) { var e = document.createElement(tag); if (cls)
        e.className = cls; if (html != null)
        e.innerHTML = html; return e; }
    function svgEl(tag, attrs) { var e = document.createElementNS('http://www.w3.org/2000/svg', tag); for (var k in attrs)
        e.setAttribute(k, attrs[k]); return e; }
    function fade(el, t, a, b, rise, u) {
        var p = eOut(prog(t, a, b));
        el.style.opacity = p.toFixed(3);
        el.style.transform = 'translate3d(0,' + px((1 - p) * rise * u) + ',0)';
    }
    function maskStops(_dir, from, to, a0, n) {
        var s = [];
        for (var i = 0; i <= n; i++) {
            var k = i / n;
            s.push('rgba(0,0,0,' + lerp(a0, 1, ss(k)).toFixed(3) + ') ' + lerp(from, to, k).toFixed(1) + '%');
        }
        return s;
    }
    // window glows + sun, in image pixel coordinates (cx, cy, w, h, start time)
    var GLOWS = [[278, 592, 300, 170, 9.2], [528, 580, 430, 210, 9.55], [733, 594, 170, 150, 9.9], [1040, 592, 330, 170, 10.25], [1255, 590, 320, 170, 10.6]];
    var SUN = [1432, 488, 260, 260];
    var LOT_GRID = {
        land: ['M0 22H100', 'M0 50H38', 'M58 74H100', 'M0 86H100', 'M12 0V100', 'M30 0V44', 'M46 70V100', 'M66 0V100', 'M90 0V100', 'M0 100L44 8'],
        port: ['M0 14H100', 'M0 34H100', 'M0 50H52', 'M0 66H100', 'M0 88H100', 'M10 0V100', 'M48 0V30', 'M60 54V100', 'M92 0V100', 'M0 96L64 0']
    };
    var ROUTE = { land: [[16, 64], [38, 64], [52, 40], [80, 40]], port: [[20, 75], [20, 59], [80, 43], [80, 28]] };
    function createMove(root, opts) {
        var self = {}, destroyed = false;
        var timers = [], cleanups = [];
        root.t2hMove = self;
        self.root = root;
        var src = opts.src;
        // Version B: open on the current store when data-old-src is set
        var oldSrc = opts.oldSrc;
        var B = !!oldSrc, OFF = 1.6, TOTAL = B ? DUR + OFF : DUR;
        var completed = false;
        function complete() {
            if (completed)
                return;
            completed = true;
            if (opts.onComplete)
                opts.onComplete();
        }
        self.duration = TOTAL;
        // ---------- build DOM ----------
        var deco = h('div', 't2h-layer');
        deco.setAttribute('aria-hidden', 'true');
        var map = svgEl('svg', { 'class': 't2h-layer t2h-map' });
        var grid = svgEl('g', { 'class': 't2h-grid' });
        var routeBg = svgEl('path', { 'class': 't2h-route-bg' });
        var route = svgEl('path', { 'class': 't2h-route' });
        map.appendChild(grid);
        map.appendChild(routeBg);
        map.appendChild(route);
        deco.appendChild(map);
        var ghost = h('div', 't2h-ghost'), ring = h('div', 't2h-ring');
        var from = h('div', 't2h-label t2h-from', '<span class="k">' + COPY.leavingLabel + '</span><span class="a">' + COPY.oldAddress + '<s></s></span>');
        var to = h('div', 't2h-label t2h-to', '<span class="k">' + COPY.newHomeLabel + '</span><span class="a">' + COPY.newAddress + '</span>');
        var logoSvg = '<svg viewBox="51 31 1339 717" preserveAspectRatio="xMinYMin meet"><path fill-rule="evenodd" d="' + LETTERS + '"/></svg>';
        var intro = h('div', 't2h-logo t2h-intro', logoSvg);
        deco.appendChild(ghost);
        deco.appendChild(ring);
        deco.appendChild(from);
        deco.appendChild(to);
        deco.appendChild(intro);
        var photo = h('div', 't2h-photo');
        var img = h('div', 't2h-img');
        var im = new Image();
        im.alt = '';
        im.decoding = 'sync';
        im.src = src;
        if (im.decode)
            im.decode().catch(function () { });
        img.appendChild(im);
        var glows = GLOWS.map(function (g) { var e = h('i', 't2h-glow'); place(e, g[0], g[1], g[2], g[3]); img.appendChild(e); return e; });
        var sun = h('i', 't2h-sun');
        place(sun, SUN[0], SUN[1], SUN[2], SUN[3]);
        img.appendChild(sun);
        photo.appendChild(img);
        var frame = h('div', 't2h-frame');
        var dot = h('div', 't2h-dot');
        var old, oldImg, patch, cap;
        if (B) {
            old = h('div', 't2h-old');
            oldImg = h('div', 't2h-old-img');
            var oim = new Image();
            oim.alt = '';
            oim.decoding = 'sync';
            oim.src = oldSrc;
            oldImg.appendChild(oim);
            if (oim.decode)
                oim.decode().catch(function () { });
            patch = h('i', 't2h-patch');
            patch.style.left = (100 * OLD.patch[0] / OLD.w) + '%';
            patch.style.top = (100 * OLD.patch[1] / OLD.h) + '%';
            patch.style.width = (100 * (OLD.patch[2] - OLD.patch[0]) / OLD.w) + '%';
            patch.style.height = (100 * (OLD.patch[3] - OLD.patch[1]) / OLD.h) + '%';
            oldImg.appendChild(patch);
            old.appendChild(oldImg);
            cap = h('div', 't2h-cap', '<span class="k">' + COPY.oldAddress + '</span><span class="a">' + COPY.oldCaption + '</span>');
            old.appendChild(cap);
            deco.appendChild(old);
        }
        deco.appendChild(photo);
        deco.appendChild(frame);
        deco.appendChild(dot);
        var flogo = h('div', 't2h-logo t2h-flogo', logoSvg + '<i></i>');
        flogo.setAttribute('role', 'img');
        flogo.setAttribute('aria-label', 't2h');
        var fsq = flogo.querySelector('i');
        var copy = h('div', 't2h-copy');
        var eyebrow = h('p', 't2h-eyebrow', COPY.eyebrow);
        var head = h('h2', 't2h-h', '<span>' + COPY.headingTop + '</span><span><strong>' + COPY.headingBold + '</strong><b></b></span>');
        var hl = head.querySelectorAll('span');
        var rule = h('div', 't2h-rule');
        rule.setAttribute('aria-hidden', 'true');
        var addr = h('div', 't2h-addr', '<p class="k">' + COPY.newHomeLabel + '</p><p class="a">' + COPY.newAddress + '</p><p class="c">' + COPY.cityLine + '</p>');
        var note = h('p', 't2h-note', '<strong>' + COPY.noteBold + '</strong> ' + COPY.noteRest);
        [eyebrow, head, rule, addr, note].forEach(function (e) { copy.appendChild(e); });
        var ctrl = h('button', 't2h-ctrl', '<svg data-i="pause" viewBox="0 0 16 16"><rect x="3.5" y="2.5" width="3" height="11" fill="currentColor"/><rect x="9.5" y="2.5" width="3" height="11" fill="currentColor"/></svg>' +
            '<svg data-i="play" viewBox="0 0 16 16"><path d="M4 2.5v11l9.5-5.5z" fill="currentColor"/></svg>' +
            '<svg data-i="replay" viewBox="0 0 16 16"><path d="M13.2 8a5.2 5.2 0 1 1-1.6-3.75" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12.6 1.6v3.3H9.3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>');
        ctrl.type = 'button';
        root.innerHTML = '';
        root.appendChild(deco);
        root.appendChild(flogo);
        root.appendChild(copy);
        root.appendChild(ctrl);
        if (!root.hasAttribute('aria-label')) {
            root.setAttribute('role', 'region');
            root.setAttribute('aria-label', COPY.ariaLabel);
        }
        function place(e, cx, cy, w, hh) {
            e.style.left = (100 * (cx - w / 2) / IMG_W) + '%';
            e.style.top = (100 * (cy - hh / 2) / IMG_H) + '%';
            e.style.width = (100 * w / IMG_W) + '%';
            e.style.height = (100 * hh / IMG_H) + '%';
        }
        // ---------- layout ----------
        var G = {};
        function layout() {
            var W = root.clientWidth;
            var H = root.clientHeight;
            if (!W || !H)
                return;
            var port = W / H < 1.15;
            root.classList.toggle('is-port', port);
            var u = port ? Math.min(W / 100, H / 133) : Math.min(W / 100, H / 56.25);
            root.style.setProperty('--u', u + 'px');
            map.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
            map.setAttribute('width', W);
            map.setAttribute('height', H);
            var key = port ? 'port' : 'land';
            // grid
            grid.innerHTML = '';
            G.grid = LOT_GRID[key].map(function (d) {
                var dd = d.replace(/([MLHV])\s*([\d.]+)(?:\s+([\d.]+))?/g, function (_m, c, a, b) {
                    if (c === 'H')
                        return 'H' + (a * W / 100);
                    if (c === 'V')
                        return 'V' + (a * H / 100);
                    return c + (a * W / 100) + ' ' + (b * H / 100);
                });
                var p = svgEl('path', { d: dd, pathLength: '1', 'stroke-dasharray': '1 1' });
                grid.appendChild(p);
                return p;
            });
            // route
            var pts = ROUTE[key].map(function (p) { return [p[0] * W / 100, p[1] * H / 100]; });
            var d = 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' L');
            route.setAttribute('d', d);
            routeBg.setAttribute('d', d);
            G.len = route.getTotalLength();
            var S = Math.max(10, port ? u * 4.2 : u * 1.9);
            route.style.strokeWidth = px(Math.max(2, S * .16));
            route.style.strokeDasharray = G.len + ' ' + G.len;
            routeBg.style.strokeWidth = px(Math.max(1.5, S * .1));
            G.S = S;
            G.start = pts[0];
            G.end = pts[pts.length - 1];
            // labels
            var lf = from.getBoundingClientRect(), lt = to.getBoundingClientRect();
            if (port) {
                G.fromXY = [G.start[0] + S * 1.3, G.start[1] - lf.height / 2];
                G.toXY = [G.end[0] - S * 1.3 - lt.width, G.end[1] - lt.height / 2];
            }
            else {
                G.fromXY = [G.start[0] - S / 2, G.start[1] + S * 1.4];
                G.toXY = [G.end[0] + S / 2 - lt.width, G.end[1] - S * 1.4 - lt.height];
            }
            // intro logo
            var LW = port ? Math.min(W * .5, H * .3 / .5355) : Math.min(W * .26, H * .5 / .5355);
            var LH = LW * .5355;
            G.intro = [(W - LW) / 2, (H - LH) / 2, LW];
            G.sq0 = [G.intro[0] + LW * .911, G.intro[1] + LH * .828, LW * .0889];
            G.port = port;
            G.W = W;
            G.H = H;
            G.u = u;
            if (B) {
                var og = oldGeom(4.0), osz = OLD.cs * og.s * 1.15;
                G.sq0 = [og.x - osz / 2, og.y - osz / 2 - osz * .12, osz];
            }
            // final layout
            var tall = H / W > 1.5;
            G.photoEnd = port ? [0, 0, W, H * (tall ? .6 : .56)] : [W * .37, 0, W * .63, H];
            G.focusEnd = port ? [.44, .52] : [.4, .56];
            G.port = port;
            G.W = W;
            G.H = H;
            G.u = u;
            var fl = port ? [W * .07, H * .035, W * .2] : [W * .06, H * .085, W * .085];
            if (port)
                fl[2] = Math.min(fl[2], H * .14 / .5355);
            flogo.style.width = px(fl[2]);
            flogo.style.left = px(fl[0]);
            flogo.style.top = px(fl[1]);
            if (port) {
                copy.style.left = px(W * .07);
                copy.style.right = px(W * .07);
                copy.style.width = 'auto';
                copy.style.top = 'auto';
                copy.style.bottom = px(Math.max(H * .06, u * 8));
                copy.style.transform = '';
            }
            else {
                copy.style.left = px(W * .06);
                copy.style.width = px(W * .33);
                copy.style.right = 'auto';
                copy.style.bottom = 'auto';
                copy.style.top = px(Math.max(H * .22, fl[1] + fl[2] * .5355 + u * 4));
            }
            self.seek(self.t, true);
        }
        // ---------- frame renderer: every style is a pure function of t ----------
        function renderBase(t) {
            if (!G.W)
                return;
            var W = G.W, H = G.H, u = G.u, S = G.S;
            // intro letters
            var lin = eOut(prog(t, .3, 1.4)), lout = eInOut(prog(t, 2.1, 2.7));
            intro.style.width = px(G.intro[2]);
            intro.style.opacity = (lin * (1 - lout)).toFixed(3);
            intro.style.clipPath = 'inset(' + ((1 - lin) * 100).toFixed(1) + '% 0 0 0)';
            intro.style.transform = 'translate3d(' + px(G.intro[0]) + ',' + px(G.intro[1] + (1 - lin) * u * 2) + ',0) scale(' + (1 - lout * .04) + ')';
            // the red square: logo -> route start -> along route
            var x, y, s, op = 1;
            var pop = prog(t, 1.05, 1.6), toStart = eInOut(prog(t, 2.35, 3.4)), travel = eInOut(prog(t, 4.0, 7.0));
            if (t < 2.35) {
                s = G.sq0[2] * clamp(eBack(pop), 0, 1.3);
                x = G.sq0[0] + G.sq0[2] / 2;
                y = G.sq0[1] + G.sq0[2] / 2;
                if (pop <= 0)
                    op = 0;
            }
            else if (t < 4.0) {
                x = lerp(G.sq0[0] + G.sq0[2] / 2, G.start[0], toStart);
                y = lerp(G.sq0[1] + G.sq0[2] / 2, G.start[1], toStart);
                s = lerp(G.sq0[2], S, toStart);
            }
            else {
                var pt = route.getPointAtLength(G.len * travel);
                x = pt.x;
                y = pt.y;
                s = S;
            }
            var arrive = prog(t, 7.0, 7.35);
            s *= 1 + .18 * Math.sin(Math.PI * arrive);
            op *= 1 - prog(t, 7.6, 7.9);
            dot.style.opacity = op;
            dot.style.width = px(s);
            dot.style.height = px(s);
            dot.style.transform = 'translate3d(' + px(x - s / 2) + ',' + px(y - s / 2) + ',0)';
            // map grid + route
            var mapOut = prog(t, 7.6, 8.4);
            G.grid.forEach(function (p, i) { p.style.strokeDashoffset = (1 - eInOut(prog(t, 2.4 + i * .12, 3.8 + i * .12))).toFixed(4); });
            grid.style.opacity = 1 - mapOut;
            routeBg.style.opacity = (prog(t, 3.0, 3.6) * (1 - mapOut)).toFixed(3);
            route.style.strokeDashoffset = (G.len * (1 - travel)).toFixed(2);
            route.style.opacity = t < 4.0 ? 0 : 1 - mapOut;
            ghost.style.width = ghost.style.height = px(S);
            ghost.style.transform = 'translate3d(' + px(G.start[0] - S / 2) + ',' + px(G.start[1] - S / 2) + ',0)';
            ghost.style.opacity = (t > 4.05 ? 1 : 0) * (1 - mapOut);
            var rp = prog(t, 7.0, 7.9);
            ring.style.width = ring.style.height = px(S * (1 + rp * 2.2));
            ring.style.transform = 'translate3d(' + px(G.end[0] - S * (1 + rp * 2.2) / 2) + ',' + px(G.end[1] - S * (1 + rp * 2.2) / 2) + ',0)';
            ring.style.opacity = rp > 0 && rp < 1 ? (1 - rp).toFixed(3) : 0;
            // labels
            var fIn = eOut(prog(t, 3.2, 3.9)), tIn = eOut(prog(t, 6.6, 7.3));
            from.style.opacity = (fIn * (1 - mapOut) * (1 - .45 * prog(t, 4.6, 5.3))).toFixed(3);
            from.style.transform = 'translate3d(' + px(G.fromXY[0]) + ',' + px(G.fromXY[1] + (1 - fIn) * u) + ',0)';
            from.querySelector('s').style.transform = 'scaleX(' + eInOut(prog(t, 4.6, 5.3)).toFixed(3) + ')';
            to.style.opacity = (tIn * (1 - mapOut)).toFixed(3);
            to.style.transform = 'translate3d(' + px(G.toXY[0]) + ',' + px(G.toXY[1] + (1 - tIn) * u) + ',0)';
            // photo: square wipe, push-in, settle into layout
            var wipe = eInOut(prog(t, 7.6, 9.0)), settle = eInOut(prog(t, 14.2, 15.8));
            var pe = G.photoEnd;
            var bx = lerp(0, pe[0], settle), by = lerp(0, pe[1], settle), bw = lerp(W, pe[2], settle), bh = lerp(H, pe[3], settle);
            photo.style.opacity = t < 7.6 ? .001 : 1;
            photo.style.width = px(bw);
            photo.style.height = px(bh);
            photo.style.transform = 'translate3d(' + px(bx) + ',' + px(by) + ',0)';
            var cl = G.end[0] - S / 2, ct = G.end[1] - S / 2;
            var iL = lerp(cl, 0, wipe), iT = lerp(ct, 0, wipe), iR = lerp(W - cl - S, 0, wipe), iB = lerp(H - ct - S, 0, wipe);
            photo.style.clipPath = wipe < 1 ? 'inset(' + px(iT) + ' ' + px(iR) + ' ' + px(iB) + ' ' + px(iL) + ')' : 'none';
            frame.style.display = t >= 7.6 && wipe < 1 ? 'block' : 'none';
            frame.style.width = px(W - iL - iR);
            frame.style.height = px(H - iT - iB);
            frame.style.transform = 'translate3d(' + px(iL) + ',' + px(iT) + ',0)';
            frame.style.opacity = (1 - wipe).toFixed(3);
            // cover-fit image with a slow push-in
            var zoom = lerp(1.0, 1.085, ss(prog(t, 7.6, DUR)));
            var fx = lerp(G.port ? .37 : .42, G.focusEnd[0], settle), fy = lerp(.55, G.focusEnd[1], settle);
            var sc = Math.max(bw / IMG_W, bh / IMG_H) * zoom, iw = IMG_W * sc, ih = IMG_H * sc;
            img.style.width = px(iw);
            img.style.height = px(ih);
            img.style.transform = 'translate3d(' + px((bw - iw) * fx) + ',' + px((bh - ih) * fy) + ',0)';
            // masks: image dissolves into white, as in the flyer
            var m;
            if (G.port) {
                m = 'linear-gradient(to bottom, ' + maskStops(0, 0, 24, 1 - settle * .9, 8).join(', ') + ', ' + maskStops(0, 100, 48, 1 - settle, 10).reverse().join(', ') + ')';
            }
            else {
                m = 'linear-gradient(to right, ' + maskStops(0, 0, 46, 1 - settle, 12).join(', ') + ')';
            }
            photo.style.webkitMaskImage = m;
            photo.style.maskImage = m;
            // window lights, sun shimmer
            GLOWS.forEach(function (g, i) {
                var a = eOut(prog(t, g[4], g[4] + .55)), b = prog(t, g[4] + .55, g[4] + 1.6);
                glows[i].style.opacity = (a * lerp(1, .55, ss(b))).toFixed(3);
            });
            sun.style.opacity = (prog(t, 8.2, 9.5) * (.5 + .2 * Math.sin(t * 1.7))).toFixed(3);
            // final logo + copy
            var lo = eOut(prog(t, 15.0, 15.8));
            flogo.style.opacity = lo.toFixed(3);
            flogo.style.transform = 'translate3d(0,' + px((1 - lo) * u) + ',0)';
            fsq.style.transform = 'scale(' + clamp(eBack(prog(t, 15.5, 16.0)), 0, 1.4).toFixed(3) + ')';
            fade(eyebrow, t, 15.2, 15.9, 1.2, u);
            fade(hl[0], t, 15.4, 16.2, 1.6, u);
            fade(hl[1], t, 15.65, 16.45, 1.6, u);
            var rl = eOut(prog(t, 16.1, 16.8));
            rule.style.transform = 'scaleX(' + rl.toFixed(3) + ')';
            rule.style.transformOrigin = 'left';
            rule.style.opacity = .35 * (rl > 0 ? 1 : 0);
            fade(addr, t, 16.3, 17.0, 1.2, u);
            fade(note, t, 16.6, 17.3, 1.2, u);
        }
        // Version B opening: current store, push in on the sign, the red cube lifts off
        function oldGeom(t) {
            var W = G.W, H = G.H;
            var s = Math.max(W / OLD.w, H / OLD.h) * lerp(1, 1.32, eInOut(prog(t, 0, 4.2)));
            var iw = OLD.w * s, ih = OLD.h * s;
            var nx = (W - iw) / 2 + OLD.cx * s, ny = (H - ih) / 2 + OLD.cy * s;
            var e = ss(prog(t, 0, 3.4));
            var px_ = lerp(nx, W * .5, e), py_ = lerp(ny, H * (G.port ? .42 : .45), e);
            var left = clamp(px_ - OLD.cx * s, W - iw, 0), top = clamp(py_ - OLD.cy * s, H - ih, 0);
            return { left: left, top: top, iw: iw, ih: ih, s: s, x: left + OLD.cx * s, y: top + OLD.cy * s };
        }
        function renderOld(t) {
            var g = oldGeom(t), u = G.u;
            var fadeOut = eInOut(prog(t, 3.45, 4.15));
            old.style.opacity = (1 - fadeOut).toFixed(3);
            oldImg.style.width = px(g.iw);
            oldImg.style.height = px(g.ih);
            oldImg.style.transform = 'translate3d(' + px(g.left) + ',' + px(g.top) + ',0)';
            var lift = prog(t, 3.05, 3.6);
            patch.style.opacity = t >= 3.05 ? 1 : 0;
            var ci = eOut(prog(t, .5, 1.2)), co = eInOut(prog(t, 2.7, 3.2));
            cap.style.opacity = (ci * (1 - co)).toFixed(3);
            cap.style.transform = 'translate3d(0,' + px((1 - ci) * u * 1.2) + ',0)';
            var size = OLD.cs * g.s * lerp(1, 1.15, eOut(lift));
            var c = eOut(prog(t, 3.1, 3.7));
            dot.style.opacity = t >= 3.05 ? 1 : 0;
            dot.style.background = 'rgb(' + Math.round(lerp(226, 255, c)) + ',' + Math.round(lerp(26, 51, c)) + ',' + Math.round(lerp(22, 19, c)) + ')';
            dot.style.boxShadow = '0 ' + px(size * .25 * Math.sin(Math.PI * clamp(lift * 1.2, 0, 1))) + ' ' + px(size * .6) + ' rgba(40,20,10,' + (.35 * Math.sin(Math.PI * lift)).toFixed(3) + ')';
            dot.style.width = px(size);
            dot.style.height = px(size);
            dot.style.transform = 'translate3d(' + px(g.x - size / 2) + ',' + px(g.y - size / 2 - size * .12 * eOut(lift)) + ',0)';
        }
        function render(t) {
            if (!G.W)
                return;
            if (!B)
                return renderBase(t);
            if (t < 4.0) {
                renderBase(0);
                intro.style.opacity = 0;
                old.style.display = 'block';
                renderOld(t);
            }
            else {
                old.style.display = 'none';
                dot.style.background = '';
                dot.style.boxShadow = '';
                renderBase(t - OFF);
                intro.style.opacity = 0;
            }
        }
        // ---------- playback ----------
        self.t = 0;
        self.playing = false;
        var raf = 0, last = 0;
        function tick(now) {
            if (!self.playing)
                return;
            var dt = Math.min(.1, (now - last) / 1000);
            last = now;
            self.t = Math.min(TOTAL, self.t + dt);
            render(self.t);
            if (self.t >= TOTAL) {
                self.playing = false;
                root.setAttribute('data-state', 'ended');
                ctrl.setAttribute('aria-label', 'Replay animation');
                complete();
                return;
            }
            raf = requestAnimationFrame(tick);
        }
        self.seek = function (t, keep) { self.t = clamp(+t || 0, 0, TOTAL); render(self.t); if (self.t >= TOTAL)
            complete(); if (!keep && !self.playing)
            root.setAttribute('data-state', self.t >= TOTAL ? 'ended' : 'paused'); };
        self.play = function () {
            if (self.t >= TOTAL)
                self.t = 0;
            if (self.playing)
                return;
            self.playing = true;
            root.setAttribute('data-state', 'playing');
            ctrl.setAttribute('aria-label', 'Pause animation');
            last = performance.now();
            raf = requestAnimationFrame(tick);
        };
        self.pause = function () { self.playing = false; cancelAnimationFrame(raf); root.setAttribute('data-state', self.t >= TOTAL ? 'ended' : 'paused'); ctrl.setAttribute('aria-label', 'Play animation'); };
        self.replay = function () { completed = false; if (opts.onReplay)
            opts.onReplay(); self.pause(); self.t = 0; self.play(); };
        ctrl.addEventListener('click', function () {
            var st = root.getAttribute('data-state');
            if (st === 'playing') {
                self.userPaused = true;
                self.pause();
            }
            else if (st === 'ended')
                self.replay();
            else {
                self.userPaused = false;
                self.play();
            }
        });
        // ---------- start ----------
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var ro = null, io = null;
        if (window.ResizeObserver) {
            ro = new ResizeObserver(function () { if (!destroyed)
                layout(); });
            ro.observe(root);
        }
        else {
            window.addEventListener('resize', layout);
            cleanups.push(function () { window.removeEventListener('resize', layout); });
        }
        layout();
        if (document.fonts && document.fonts.ready)
            document.fonts.ready.then(function () { if (!destroyed)
                layout(); });
        if (reduce) {
            self.seek(TOTAL);
        }
        else {
            self.seek(0);
            var started = false;
            var start = function () { if (!started && !destroyed) {
                started = true;
                self.play();
            } };
            if (window.IntersectionObserver) {
                io = new IntersectionObserver(function (es) {
                    es.forEach(function (e) {
                        if (destroyed)
                            return;
                        if (e.isIntersecting && e.intersectionRatio >= .35) {
                            if (!started) {
                                if (im.complete)
                                    start();
                                else
                                    im.addEventListener('load', start, { once: true });
                                timers.push(setTimeout(start, 2500));
                            }
                            else if (!self.userPaused && self.t < TOTAL)
                                self.play();
                        }
                        else if (!e.isIntersecting && self.playing)
                            self.pause();
                    });
                }, { threshold: [0, .35] });
                io.observe(root);
            }
            else
                start();
            var onVis = function () { if (document.hidden && self.playing)
                self.pause(); };
            document.addEventListener('visibilitychange', onVis);
            cleanups.push(function () { document.removeEventListener('visibilitychange', onVis); });
        }
        // ---------- cleanup (React unmount / re-init) ----------
        self.destroy = function () {
            destroyed = true;
            self.playing = false;
            cancelAnimationFrame(raf);
            timers.forEach(clearTimeout);
            if (ro)
                ro.disconnect();
            if (io)
                io.disconnect();
            cleanups.forEach(function (fn) { fn(); });
            root.innerHTML = '';
            ['data-state', 'aria-label', 'role', 'style'].forEach(function (a) { root.removeAttribute(a); });
            root.classList.remove('is-port');
            delete root.t2hMove;
        };
        return self;
    }
    return createMove;
}
const createMove = buildEngine();

  /* ------------------------- Shopify glue ------------------------- */

  function readOffset(sec) {
    var v = parseFloat(getComputedStyle(sec).getPropertyValue('--t2h-offset'));
    return isNaN(v) ? 151 : v;
  }

  // Safeguard: if the theme limits the width of the page content, stretch this section edge to edge.
  function fitFullWidth(sec) {
    sec.style.width = ''; sec.style.marginLeft = '';
    var vw = document.documentElement.clientWidth;
    var r = sec.getBoundingClientRect();
    if (Math.abs(r.width - vw) <= 1 && Math.abs(r.left) <= 1) return;
    var ml = parseFloat(getComputedStyle(sec).marginLeft) || 0;
    sec.style.width = vw + 'px';
    sec.style.marginLeft = (ml - r.left) + 'px';
  }

  // Scroll so the next section starts right under the sticky header.
  function scrollToNext(sec) {
    var wrap = sec.closest('.shopify-section') || sec;
    var next = wrap.nextElementSibling;
    while (next && !next.classList.contains('shopify-section')) next = next.nextElementSibling;
    var off = readOffset(sec);
    var top = next ? next.getBoundingClientRect().top + window.pageYOffset - off
                   : window.pageYOffset + window.innerHeight - off;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  function initSection(sec) {
    if (!sec || sec._t2h) return;
    var root = sec.querySelector('.t2h-move');
    var btn = sec.querySelector('.t2h-scroll');
    if (!root) return;

    var onResize = function () { fitFullWidth(sec); };
    fitFullWidth(sec);
    window.addEventListener('resize', onResize);

    var onBtn = function () { scrollToNext(sec); };
    if (btn) { btn.classList.remove('is-on'); btn.addEventListener('click', onBtn); }

    var engine = createMove(root, {
      src: root.getAttribute('data-src') || '',
      oldSrc: root.getAttribute('data-old-src') || '',
      onComplete: function () { if (btn) btn.classList.add('is-on'); },
      onReplay: function () { if (btn) btn.classList.remove('is-on'); }
    });

    sec._t2h = {
      engine: engine,
      destroy: function () {
        window.removeEventListener('resize', onResize);
        if (btn) btn.removeEventListener('click', onBtn);
        engine.destroy();
        sec.style.width = ''; sec.style.marginLeft = '';
        sec._t2h = null;
      }
    };
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-t2h-section]');
    for (var i = 0; i < list.length; i++) initSection(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Shopify theme editor: re-init when the section is re-rendered or removed.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector && e.target.querySelector('[data-t2h-section]');
    if (s && s._t2h) s._t2h.destroy();
  });
})();
